export enum BankHourHistoryType {
  ENTRY = 'entry',
  EXIT = 'exit',
}

export type BankHour = {
  id: number;
  user: number;
  username: string;
  createdAt: string;
  amount: number;
  dailyWorkAmount: number;
  updatedAt: string;
  createdBy: string;
  composedAmount: string;
  companyName: string;
};

export type BankHourHistory = {
  id: number;
  bankHour: number;
  amount: number;
  type: BankHourHistoryType;
  description: string;
  createdBy: string;
  createdAt: string;
  deletedBy: string;
  deletedAt: string;
};
